<template>
    <el-drawer v-model="optionparam.view" size="20%" direction="rtl" :before-close="handleClose">
        <el-empty description="暂无数据" v-if="goodslist.length==0" />
        <div class="ttl-goods-list" @scroll="handleScroll($event)" v-loading="LoadingObj" v-if="goodslist.length > 0">
            <div class="ttl-goods-infos" v-for="(item,index) in goodslist" :key="index">
                <el-image :src="item.thumb" fit="cover" />
                <div class="ttl-price top10"><i>售价￥</i>{{item.price}}<span>{{item.Fineness}}</span></div>
                <div class="ttl-name top10">{{item.name}}</div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';

export default {
    props:['view','option'],
    components:{

    },
    data() {
        return {
            LoadingObj:false,  //loading对象   
            optionparam: {
                view:false,
                type:'',
                memberid:'',
                p:0,
                rollpage:5,
            },
            isloading:false,
            isfinish:false,
            goodslist:[],
        }
    },
    
    watch: {
        view(val) {
            if(val) {
                this.isfinish=false;
                this.optionparam.view=true;
                this.optionparam.p=0;
                for(var i in this.option) this.optionparam[i]=this.option[i];
                this.goodslist=[];
                this.GetList();
            }
        }
    },

    methods: {

        //关闭窗口
        handleClose() {
            this.optionparam.view=false;
            this.$emit('finish',{type:'close'});
        },

        //查看关注商品信息
        GetList() {
            if(this.isfinish) return true; //数据已经滚动完成
            if(this.isloading) return false;
            this.isloading=true;

            this.optionparam.p++;
            var param={memberid:this.optionparam.memberid,p:this.optionparam.p,rollpage:this.optionparam.rollpage};
            var method='';
            if(this.optionparam.type=='sale') {param.type=1;method='GET_LIST';}
            if(this.optionparam.type=='buy') {param.type=2;method='GET_LIST';}
            if(this.optionparam.type=='collect') {method='GET_COLLECT_GOODS'}

            this.LoadingObj=true;
            INTERFACE_MODEL_GOODS[method](param).then((res) => {
                 this.LoadingObj=false;
                 if(res.status > 0) return false;
                 if(res.data.list.length==0) this.isfinish=true;
                 for(var i=0;i < res.data.list.length;i++) this.goodslist.push(res.data.list[i]);
                 this.isloading=false;
            });
        },  


        //滚动触发操作
        handleScroll(event) {
            const{ scrollTop, scrollHeight, clientHeight }=event.target;
            //检查是否滚动到底部
            const isBottom = scrollHeight - (scrollTop + clientHeight) < 100; // 这里的1是一个阈值，可以根据需要调整
            if(isBottom) {
                this.GetList();
            }
        },

    },
}
</script>
<style scoped>
.ttl-goods-list {display: inline-block;width:100%;height:100%;overflow-y:auto;}
.ttl-goods-infos {display: inline-block;width:100%;font-size:0;margin-bottom:20px;padding-bottom:30px;border-bottom:1px solid #F0F2F5}
.ttl-goods-infos .el-image {display: inline-block;width:100%;height: 260px;border-radius: 6px 6px 0 0;}
.ttl-price {display: inline-flex;width:100%;align-content: center;font-size:15px;font-weight: 650;position: relative;color:#e32020;}
.ttl-price i {font-style:normal;font-size:12px;font-weight:normal;margin-right:5px;color:#333333;margin-top:5px;}
.ttl-price span {position:absolute;right:0;font-size:12px;color:#333333;font-weight: normal;padding:5px 15px;border-radius: 15px;border:1px solid #dfc471;}
.ttl-name {display: inline-block;width:100%;font-size:13px;line-height: 18px;}
::-webkit-scrollbar {width:0;}
.el-drawer__body::-webkit-scrollbar {width:0;}
</style>